import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Modal, Button, message, Spin, Checkbox } from 'antd';
import { PhoneOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { MaskedInput } from 'antd-mask-input';
import { userLoaded } from '@redux';
import { serverFetch, getIsVkSession, getVkSession } from '@extensions';
import './auth.css';

const Auth = ({ ...props }) => {
  const d = useDispatch();
  const { onClose, open: openProp } = props;
  const [form] = Form.useForm();
  const [authData, setAuthData] = useState({});
  const company = useSelector((s) => s.company);
  const user = useSelector((s) => s.user);
  const [logining, setLogining] = useState(false);
  const [intervaled, setIntervaled] = useState();
  const navigate = useNavigate();
  const [page, setPage] = useState(0); // Страница: 0 - основная, 1 - ВК ожидание, 2 - телефон ожидание, 3 - вход по логину/паролю
  const [isRotating, setIsRotating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneCheckInterval, setPhoneCheckInterval] = useState(null);

  useEffect(() => { user && onClose() }, [user]);

  useEffect(() => {
      form.resetFields();
      setPhoneNumber('');
      if (phoneCheckInterval) {
        clearInterval(phoneCheckInterval);
        setPhoneCheckInterval(null);
      }
  }, [form, phoneCheckInterval]);

  // Очистка интервала при размонтировании
  useEffect(() => {
    return () => {
      if (phoneCheckInterval) {
        clearInterval(phoneCheckInterval);
      }
    };
  }, [phoneCheckInterval]);

  const onValuesChange = (value) => {
    if (value.phone && !value.phone.startsWith('+7')) {
      const normalized = value.phone.replace(/^\+\d?/, '+7');
      form.setFieldValue('phone', normalized);
      setAuthData({ ...authData, phone: normalized });
      return;
    }
    setAuthData({ ...authData, ...value });
  };

  const isPhoneValid = phoneNumber && phoneNumber.indexOf('_') < 0 && phoneNumber.replace(/\s/g, '').length >= 12;

  const startR = authCode => {
    const interval = setInterval(() => {
      serverFetch(`auth/auth-check`, {
        method: 'GET',
        queryParams: { id: authCode }
      })
        .then((data) => {
          if (data) {
            clearInterval(interval);
            d(userLoaded(data));
            onClose();
          }
        })
        .catch(e => {
          console.log(`Ошибка ${e.UserMessage}`);
          clearInterval(interval);
          ChangePage(0);
        });
    }, 1000);
    setIntervaled(interval)
  }

  const isVkSession = getIsVkSession();

  const openDeepLinkWithFallback = (deepLink) => {
    const timeout = 10000;
    const width = 800;
    const height = 300;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const popup = window.open(deepLink, '_blank', `width=${width},height=${height},left=${left},top=${top}`);

    setTimeout(() => {
      if (popup && !popup.closed) popup.close();
    }, timeout);
  };

  const startMaxLogin = () => {
    if (!privacyAccepted) return;
    setLoading(true);
    serverFetch(`auth/auth-start`, {
      method: 'GET',
      queryParams: { providerVk: 'max' }
    })
      .then(data => {
        ChangePage(1);
        startR(data.authCode);
        setLoading(false);
        openDeepLinkWithFallback(data.url);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.UserMessage);
      });
  }

  const startVkLogin = (provider) => {
    if (!privacyAccepted) return;
    if (provider !== "vkid" && isVkSession) return;
    setLoading(true);
    if (isVkSession) {
      const bodyData = JSON.parse(atob(getVkSession()));
      serverFetch(`account/signinvk`, { method: 'POST', bodyData })
        .then(data => {
          d(userLoaded(data));
        })
        .catch(e => {
          setLoading(false);
          message.error('Ошибка входа. Попробуйте перегрузить страницу и предоставить доступ приложению до данных почты и телефона');
        });
    }
    else {
      serverFetch(`auth/auth-start`, {
        method: 'GET',
        queryParams: { providerVk: provider }
      })
        .then(data => {
          ChangePage(1);
          startR(data.authCode);
          setLoading(false);
          const width = 400;
          const height = 600;
          const left = window.innerWidth / 2 - width / 2;
          const top = window.innerHeight / 2 - height / 2;
          window.open(data.url,'_blank', `width=${width},height=${height},left=${left},top=${top},noopener`);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.UserMessage);
        })
    }
  }

  const startPhoneLogin = () => {
    if (!privacyAccepted) return;
    const cleanPhone = phoneNumber.replace(/\s/g, '');
    if (!cleanPhone || cleanPhone.indexOf('_') >= 0 || cleanPhone.length < 12) {
      message.warning('Пожалуйста, введите корректный номер телефона');
      return;
    }
    console.log(cleanPhone)
    ChangePage(2)
    serverFetch(`auth/auth-start`, {
      method: 'GET',
      queryParams: { phone: cleanPhone }
    })
      .then(data => {
        ChangePage(2);
        startR(data.authCode);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.UserMessage);
      })
  }

  const onCancel = () => {
    setLogining(false);
    onClose ? onClose() : navigate(-1);
    if (intervaled) clearInterval(intervaled);
    if (phoneCheckInterval) {
      clearInterval(phoneCheckInterval);
      setPhoneCheckInterval(null);
    }
  }

  const imgClassName = isVkSession ? 'auth-img-vk-disabled' : 'auth-img-vk-enabled';

  const ChangePage = value => {
    setIsRotating(true);
    setTimeout(() => {
      setPage(value);
      setTimeout(() => {setIsRotating(false);}, 50);
    }, 300);
  }

  const getFormBody = () => {
    switch (page) {
      case 0:
        return <>
          <div className='auth-title'>Вход / регистрация</div>
          <Form.Item className='auth-privacy-item'>
            <Checkbox checked={privacyAccepted} onChange={e => setPrivacyAccepted(e.target.checked)}>
              <span className='auth-privacy-label'>
                Согласен с обработкой конфиденциальных данных в соответствии с{' '}
                <a href='/article/agreement' target='_blank' rel='noopener noreferrer' onClick={e => e.stopPropagation()}>политикой конфиденциальности</a>
              </span>
            </Checkbox>
          </Form.Item>
          <Form.Item label='Телефон'>
            <MaskedInput size='large' mask={'+7 000 000 00 00'} value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder='+7 ___ ___ __ __' type='tel' inputMode='tel' disabled={!privacyAccepted}/>
          </Form.Item>
          <Form.Item>
            <Button className='auth-btn' size='large' icon={<PhoneOutlined />} onClick={startPhoneLogin} disabled={!isPhoneValid || !privacyAccepted} block>Вход</Button>
          </Form.Item>
          <Form.Item className='auth-or'>или</Form.Item>
          <Form.Item>
            <div className={`auth-btns-ss${privacyAccepted ? '' : ' auth-btns-ss--blocked'}`}>
              <img src='/images/vk.svg' className='auth-img-vk-enabled' onClick={() => startVkLogin("vkid")} alt='vk'/>
              <img src='/images/ok.svg' className={imgClassName} onClick={() => startVkLogin("ok_ru")} alt='ok'/>
              <img src='/images/mail.svg' className={imgClassName} onClick={() => startVkLogin("mail_ru")} alt='mail'/>
              <img src='/images/max.svg' className={imgClassName} onClick={startMaxLogin} alt='max'/>
            </div>
          </Form.Item>
          {company?.tgUrl && <Form.Item>
            <a href={company?.tgUrl} target='_blank' rel='noreferrer' tabIndex={privacyAccepted ? 0 : -1} aria-disabled={!privacyAccepted} className={privacyAccepted ? '' : 'auth-tg-link--blocked'} onClick={e => { if (!privacyAccepted) e.preventDefault(); }}>
              <div className='auth-or'><span>Открыть в Telegram</span><img src='/images/tg.svg' alt='tg' style={{width: 24}}/></div>
            </a></Form.Item>}
        </>
      case 1:
        return<>
          <div className='auth-title'>Ожидание авторизации...</div>
          <div className='auth-waiting'><Spin spinning/></div>
        </>
      case 2:
        return<>
          <div className='phone-auth-waiting'>
            <div className='phone-auth-title'>Авторизация по телефону</div>
            {phoneNumber ? (
              <div className='phone-auth-client-number'>{phoneNumber}</div>
            ) : null}
            <div className='phone-auth-instruction'>Для авторизации позвоните на номер <a href='tel:+79514002000' className='phone-auth-number'>+7 951 400 2000</a></div>
            <div className='phone-auth-spinner'><Spin size="large" tip="Ожидание звонка..." /></div>
            <Form.Item><Button className='auth-btn' size='middle' icon={<ArrowLeftOutlined />} onClick={() => ChangePage(0)} block>Назад</Button></Form.Item>
          </div>
        </>
    }
  }

  return (
    <Modal forceRender open={openProp !== false} title={<div className='auth-close-btn'></div>} closable={true} footer={null} width={340} onCancel={onCancel} styles={{ margin: '-4px 20px 0'}} wrapClassName={isRotating ? 'auth-modal-rotating' : ''}>
      <Form colon={false} form={form} layout='vertical' onValuesChange={onValuesChange}>
        {getFormBody()}
      </Form>
    </Modal>
  );
};

export default Auth;
